import React from 'react';

import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from './theme';

import './assets/fonts.scss';

export const KlpTheme = (props: React.PropsWithChildren<object>) => (
    <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
);
